import { Component, HostListener, ViewChild } from '@angular/core';
import { ForgotPasswordDialogComponent } from '../../components/forgot-password/forgot-password-dialog.component';
import { FormBuilder } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { format } from 'date-fns';
import { el } from 'date-fns/locale';
import { Message, MessageService } from 'primeng/api';
import { Subscription } from 'rxjs';
import { LoginMessages } from '../../../../../assets/data/login-messages';
import { environment } from '../../../../../environments/environment';
import { AuthService } from '../../../../services/auth/auth.service';
import { authFormConfig } from './auth.config';
import { STATUS } from 'ngx-eo-web-components';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss'],
})
export class AuthComponent {
  @ViewChild('forgotPwdDialog') forgotPwdDialog?: ForgotPasswordDialogComponent;
  appTitle = environment.appTitle;
  appSubtitle = environment.appSubtitle;

  STATUS = STATUS;
  subscriptions: Subscription[] = [];
  today = format(new Date(), 'iiii dd/MM/yyyy', { locale: el });
  isStageEnvironment =
    window.location.href.toLocaleLowerCase().indexOf('stage') !== -1 ||
      window.location.href.indexOf('local') !== -1
      ? true
      : false;

  authFormConfig = authFormConfig;
  form = this.fB.group(authFormConfig.config[0]?.getFormGroup());

  authForm: { username: string; password: string; doctorSpecialtyID: number };
  submitted = false;

  appVersion = environment.appVersion;

  username = '';
  announcements: Message[] = [
    {
      severity: 'warn',
      summary: '',
      detail: `Παρατηρούνται προβλήματα ασυμβατότητας με τη χρήση SAFARI Web browser. Παρακαλώ εναλλακτικά χρησιμοποιήστε έναν από τους συμβατούς web browsers που αναφέρονται στο site του ΕΟΠΥΥ.`,
      sticky: true,
      closable: false,
    },
    {
      severity: 'info',
      summary: '',
      detail: `TEST 2`,
      sticky: true,
      closable: false,
    },
  ];
  errorMessages: Message[] = [];

  status$ = this.authService.loginStatus$;
  token$ = this.authService.token$;
  tokenStatus$ = this.authService.tokenStatus$;
  tokenError$ = this.authService.tokenError$;
  loginError$ = this.authService.loginError$;
  alertMessage: Message[] = [];

  isSticky: boolean = false;
  @HostListener('window:scroll', [])
  onScroll(): void {
    const scrollTop = window.scrollY || document.documentElement.scrollTop;
    this.isSticky = scrollTop > 55; // Adjust threshold as needed
  }

  constructor(
    private readonly router: Router,
    private readonly fB: FormBuilder,
    private route: ActivatedRoute,
    private readonly authService: AuthService,
    private messageService: MessageService,
  ) {
    this.authForm = { username: '', password: '', doctorSpecialtyID: 0 };
  }

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const refParam: string = params['ref'];
      this.setAlertMessage(refParam);
      //console.log('ref:', refParam);
    });
    this.subscribeToStoreEffects();
  }

  subscribeToStoreEffects(): void {
    this.subscriptions = [
      this.token$.subscribe((t) => {
        if (!t) return;

        this.router.navigate(['home']);
        setTimeout(() => window.dispatchEvent(new Event('resize')), 100);
      }),

      this.tokenError$.subscribe((e: any) => {
        if (!e) return;
        this.messageService.add({
          severity: 'error',
          summary: 'Αποτυχία σύνδεσης',
          detail: e,
          life: 5000,
        });
      }),
    ];
  }

  setAlertMessage(refParam: string): void {
    switch (refParam) {
      // case 'au':
      //   this.alertMessage = LoginMessages.ANAUTHORIZED;
      //   break;
      // case 'so':
      //   this.alertMessage = LoginMessages.SIGNOUT;
      //   break;
      case 're':
        this.messageService.add({
          severity: 'error',
          summary: 'Αποτυχία',
          detail: LoginMessages.REGISTERED.Message,
        });
        // this.alertMessage = [
        //   {
        //     severity: LoginMessages.REGISTERED.Type,
        //     detail: LoginMessages.REGISTERED.Message ?? '-',
        //   },
        // ];
        break;
      // case 'to':
      //   this.alertMessage = LoginMessages.TIMEOUT;
      //   break;
      // case 'rp': // Reset Pass
      //   this.alertMessage = LoginMessages.RESSETPASS;
      //   break;
      default:
        this.alertMessage = []; // Default alert message
        break;
    }
  }

  onSubmit(): void {
    this.errorMessages = [];

    let username = this.form.get('username')?.value ?? '';
    let password = this.form.get('password')?.value ?? '';
    this.authService.fetchToken(username, password);
  }


  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.subscriptions?.forEach((s) => s.unsubscribe());
  }

  isLoginLoading(): boolean {
    return this.authService.loginStatus$?.getValue() === STATUS.loading;
  }
}
